import React, { useState, useEffect } from 'react';
import { ToastContainer, Toast, Button, Modal } from 'react-bootstrap';
import axiosInstance from '../../../axiosInstance';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next';


const RemoveUser = ({ sentData, onEvent, onConfirm, changeFlag }) => {
  const navigate = useNavigate()
    const [resp,setResp] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [selectedName, setSelectedName] = useState(null);
    const [showToaster, setShowToaster] = useState(false);
    const [t] = useTranslation();

    const handleCloseModal = () => setShowModal(false);

    useEffect(() => {
        if (sentData.id && onEvent) {
            console.log(sentData);
            setSelectedId(sentData.id);
            setSelectedName(sentData.name);
            setShowModal(true);
        }
      }, [sentData, onEvent]);

      const handleDeleteRecord = (id) => {
        console.log(id, 'sentData.id', sentData.id);
        try {
          axiosInstance.delete( `/api/v1/roles/users/${id}` )
            .then(resp => {
              setShowModal(false);
              setShowToaster(true);
              changeFlag()
              navigate('/super-admin/roles/details/'+sentData.roleId);
            })
            .catch(error => {
              setResp(t('Error deleting record'), ':', error);
            });

            //setTimeout(onConfirm, 5000);
        } catch (err) {
          setResp(t('Error deleting record'), ':', err);
          console.error('Error deleting record: ', err);
        }
      };

      const DynamicModal = ({ show, handleClose, selectedId, selectedName }) => {
        return (
          <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
              <Modal.Title>Delete Record</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to remove <b>{selectedName}</b> from this role group ?
            </Modal.Body>
            <Modal.Footer>
                <Link variant="warning" className="yes-delete" onClick={() => handleDeleteRecord(selectedId)}>Confirm</Link>
                <Button size="sm" variant="light" onClick={handleClose}>
                  Cancel
                </Button>
            </Modal.Footer>
          </Modal>
        );
      };

    // const [showA, setShowA] = useState(false);

  return (
    <>
        <DynamicModal show={showModal} handleClose={handleCloseModal} selectedId={selectedId} selectedName={selectedName} />

        <ToastContainer className="p-3" position="top-end" style={{ zIndex: 1 }} >
            <Toast animation={true} autohide={true} delay={5000} show={showToaster} onClose={() => setShowToaster(false)} className="d-inline-block m-1" bg="success" key="success">
                <Toast.Header>
                <FontAwesomeIcon icon={faCheck} style={{color: "#198754",}} /> &nbsp; <div className="me-auto">Record deleted successfully</div>
                </Toast.Header>
            </Toast>
        </ToastContainer>
    </>
  );
};

export default RemoveUser;